import './style.scss'
import { useState, useContext, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import ApiContext from 'src/provider/API/call-service';
import { AppLabel, AppSpan, AppText, Button, CustomContainer, FlexColumn, FlexRow, Form, FormGroup, SidePopupContainer } from "src/style"
import helpers from 'src/utils/helpers';


export const OtpLogin: React.FC<any> = ({close}) => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const [otp, setOtp] = useState('')
    var [time, setTime] = useState<any>(null)
    var [count, setCount] = useState<any>(0)

    useEffect(() => {
        if (count === 30) API.resendLoginOtp()
    }, [count])

    useEffect(() => {
        return () => { clearInterval(time) }
    }, [])

    const handleCode = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length < 7) {
            setOtp(e.target.value)
        }
    }

    function handleResendCounter () {
        time =  setInterval(async () => {
            setCount((count: number) => {
                if (count === 30) {
                    clearInterval(time)
                    return 0
                }
                else return count + 1
            });
        }, 1000)
    }

    // function handleResendOtp () {
    //     API.resendLoginOtp()
    // }

    async function handleLogin (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        const response = await API.completeLogin(otp)
        if (response) navigate('/customer-support/overview')
    }


    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="otp-popup-container"
            >
                <CustomContainer 
                    width='80' sizeUnit='%'
                    style={{marginLeft: 'auto', marginRight: 'auto'}}
                >
                    <AppText textSize='2.8' fontWeight='600' color='#27272E' align='center'>OTP Login</AppText>
                    <AppText textSize='1.6' color='#27272E' align='center' topMargin='1'>
                        Please provide the OTP sent to your email for login
                    </AppText>
                    <Form topMargin='7' onSubmit={handleLogin}>
                        <FormGroup bottomMargin='1.5'>
                            <AppLabel>Enter OTP code</AppLabel>
                            <FlexRow width="auto" sizeUnit="">
                                <input 
                                    className='display-hidden' id='code' 
                                    name="otp" value={otp} 
                                    onChange={handleCode} 
                                    autoFocus={true} autoComplete="off"
                                />
                                <label className="code-verification" htmlFor='code' >{otp[0] || ''}</label>
                                <label className="code-verification" htmlFor='code' >{otp[1] || ''}</label>
                                <label className="code-verification" htmlFor='code' >{otp[2] || ''}</label>
                                <label className="code-verification" htmlFor='code' >{otp[3] || ''}</label>
                                <label className="code-verification" htmlFor='code' >{otp[4] || ''}</label>
                                <label className="code-verification" htmlFor='code' >{otp[5] || ''}</label>
                            </FlexRow>
                        </FormGroup>
                        <AppText color='#718096' textSize='1.2'>
                            OTP will resend in <AppSpan fontWeight='600' color='#16192C' textSize='1.2'>{helpers.formatSeconds(30-count)} sec</AppSpan>
                        </AppText>
                        <AppText color='#718096' textSize='1.2' topMargin='3'>
                            Didn’t get OTP? 
                            <AppSpan 
                                fontWeight='600' color='#4C6FFF' textSize='1.2' 
                                hoverColor='#718096' cursor='pointer' leftPadding='0.4'
                                onClick={() => count === 0 ? handleResendCounter() : null}
                            > 
                                Resend 
                            </AppSpan>
                        </AppText>
                        <Button
                            width='100' sizeUnit='%' borderColor='#4C6FFF' height='4.5'
                            hoverBgColor='#ffffff' hoverColor='#4C6FFF' bottomMargin='2.5'
                            topMargin='5'
                        >
                            Signin
                        </Button>
                    </Form>
                </CustomContainer>
            </FlexColumn>
        </>
    )
}